// ✨ components/Templates/TemplatesCatalog.js - Финальная версия с детализированными карточками
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePurchase } from '../../context/PurchaseContext';
import LoadingSpinner from '../common/LoadingSpinner';
import '../../styles/Templates.css';
import InfoTooltip from '../common/InfoTooltip';

/**
 * ✨ Компонент для отображения полей превью в зависимости от типа договора
 */
const DocumentPreviewFields = ({ templateType }) => {
    switch (templateType) {
        case 'loan':
            return (
                <>
                    <div className="doc-field"><span className="doc-label">Займодавец:</span><span className="doc-line"><span className="doc-placeholder">Ф.И.О. полностью</span></span></div>
                    <div className="doc-field"><span className="doc-label">Заемщик:</span><span className="doc-line"><span className="doc-placeholder">Ф.И.О. полностью</span></span></div>
                    <div className="doc-field"><span className="doc-label">Сумма займа:</span><span className="doc-line"><span className="doc-placeholder">100 000 рублей</span></span></div>
                </>
            );
        case 'rent':
        default:
            return (
                <>
                    <div className="doc-field"><span className="doc-label">Наймодатель:</span><span className="doc-line"><span className="doc-placeholder">Ф.И.О. полностью</span></span></div>
                    <div className="doc-field"><span className="doc-label">Наниматель:</span><span className="doc-line"><span className="doc-placeholder">Ф.И.О. полностью</span></span></div>
                    <div className="doc-field"><span className="doc-label">Плата за наём:</span><span className="doc-line"><span className="doc-placeholder">50 000 рублей</span></span></div>
                </>
            );
    }
};

/**
 * ✨ Новый компонент карточки в виде детализированного "мини-документа"
 */
const DocumentPreviewCard = ({ template, onCreateContract }) => {
    const { name = 'Договор', description = 'Описание отсутствует', type, id } = template || {};
    
    // ✨ Переопределение названия для шаблона найма жилья на клиенте
    // Это гарантирует правильное отображение даже без перезагрузки бэкенда
    const displayName = (id === 'rent_apartment' || type === 'rent') 
        ? 'ДОГОВОР НАЙМА (АРЕНДЫ) ЖИЛОГО ПОМЕЩЕНИЯ (КВАРТИРЫ) МЕЖДУ ФИЗ. ЛИЦАМИ.' 
        : name;
        
    const displayDescription = (id === 'rent_apartment' || type === 'rent')
        ? 'Стандартный договор найма жилого помещения между наймодателем и нанимателем'
        : description;

    return (
        <div className="template-card" onClick={() => onCreateContract(template)}>
            <div className="document-preview">
                <div className="doc-header-line">
                    <span className="doc-city-placeholder">г. Москва</span>
                    <span className="doc-date-placeholder">"__" ______ 20__ г.</span>
                </div>
                <h3 className="doc-title">
                    {displayName}
                    {type === 'rent' && (
                        <InfoTooltip ariaLabel="Чем аренда отличается от найма?" title="Аренда или наём?" trigger="text" position="left">
                            <p><strong>Аренда или наём?</strong></p>
                            <p>Для съёма жилья нужен договор найма квартиры между физлицами. «Аренда» применяется при участии юрлица и может касаться жилых и коммерческих объектов.</p>
                            <p>Если по сути это наём, а в названии стоит «аренда», документ может утратить юридическую силу. Между частными лицами заключается договор найма жилого помещения.</p>
                        </InfoTooltip>
                    )}
                </h3>
                <DocumentPreviewFields templateType={type} />
            </div>
            <div className="card-info">
                {/* <h2 className="card-title">{displayName}</h2> */}
                <p className="card-description">{displayDescription}</p>
                <div className="card-footer">
                    <button className="nav-button nav-button-primary" style={{ width: '100%' }}>
                        Создать договор
                    </button>
                </div>
            </div>
        </div>
    );
};

/**
 * Основной компонент каталога шаблонов
 */
const TemplatesCatalog = () => {
    const navigate = useNavigate();
    const { templates, templatesLoading, templatesLoaded, loadTemplates } = usePurchase();

    const handleCreateContract = (template) => {
        // new=1 — чистая форма; логика в ContractWizard сбросит локальный черновик гостя при необходимости
        navigate('/contract/rent?new=1');
    };

    if (templatesLoading && !templatesLoaded) {
        return <LoadingSpinner message="Загрузка каталога..." fullScreen />;
    }

    return (
        <main className="page-section">
            <div className="section-header">
                <h1>Каталог шаблонов</h1>
                <p>Наши шаблоны проверены юристами и готовы к использованию. Создайте юридически корректный документ за 5 минут.</p>
            </div>
            <div className="templates-grid">
                {templates.map(template => (
                    <DocumentPreviewCard 
                        key={template.id} 
                        template={template} 
                        onCreateContract={handleCreateContract} 
                    />
                ))}
            </div>
        </main>
    );
};

export default TemplatesCatalog;